import React, { useEffect, useRef, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useHistory } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { urlConfig } from '../../../config/urlConfig';
import { checkIsLogin } from '../../../services/global/global.service';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.ui.secondary,
  },
  form: {
    width: '100%',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    color: theme.ui.primary,
    textDecoration: 'none',
  },
}));

export default function Reset_password(props) {

  const classes = useStyles();
  const history = useHistory();
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [confirmPasswordHelperText, setConfirmPasswordHelperText] =
    useState('');
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(0);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setOpen(false);
    }
    setOpen(false);
  };

  const { token } = useParams();
  const data = {
    token,
    password: newPassword,
  };

  useEffect(() => {
    checkIsLogin(setIsLogin)
  }, [])

  const submitHandler = (e) => {
    e.preventDefault();
    if (newPassword === '') {
      setNewPasswordError(true);
      newPasswordRef.current.focus();
    }
    if (confirmPassword === '') {
      setConfirmPasswordError(true);
      if (newPassword !== '' && confirmPassword === '') {
        confirmPasswordRef.current.focus();
      }
    }
    if (newPassword && confirmPassword) {
      if (confirmPassword !== newPassword) {
        setConfirmPasswordHelperText(
          <Typography color='error' variant='caption'>
            Passwords are not equal
          </Typography>
        );
      } else {
        axios
          .post(urlConfig.confirm_password_url, data)
          .then((res) => {
            setOpen(true);
            setDisabled(true);
            setTimeout(() => {
              if(isLogin === 0){
                history.push('/signin');
              } else {
                history.push('/meetings');
              }
            }, 3000);
          })
          .catch((err) => {
            console.log(err.response.data);
            if (err.response.data) {
              err.response.data.detail &&
                setConfirmPasswordHelperText(err.response.data.detail);
              if (err.response.data.password) {
                setConfirmPasswordHelperText(err.response.data.password);
              }
            }
          });
      }
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Enter your new password
        </Typography>
        <form className={classes.form} noValidate onSubmit={submitHandler}>
          <TextField
            autoComplete='new-password'
            size='small'
            variant='outlined'
            margin='normal'
            required
            fullWidth
            label='New password'
            error={newPasswordError}
            inputRef={newPasswordRef}
            type='password'
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setNewPasswordError(false);
            }}
            autoFocus
          />
          <TextField
            size='small'
            variant='outlined'
            margin='normal'
            fullWidth
            name='confirmPassword'
            label='Confirm password'
            type='password'
            id='confirmPassword'
            helperText={
              <Typography color='error' variant='caption'>
                {confirmPasswordHelperText}
              </Typography>
            }
            autoComplete='new-password'
            error={confirmPasswordError}
            inputRef={confirmPasswordRef}
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setConfirmPasswordError(false);
            }}
            required
          />
          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
            disabled={disabled}
          >
            Submit
          </Button>
        </form>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          autoHideDuration={3000}
          onClose={handleClose}
          TransitionComponent='alpha'
          message='Password was reset successfully! redirecting...'
          action={
            <>
              <IconButton
                size='small'
                aria-label='close'
                color='inherit'
                onClick={handleClose}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </>
          }
        />
      </div>
    </Container>
  );
}
